import { Country, CountryResponse } from 'ducks/countries'

export const parseCountriesData = (data: CountryResponse): Array<Country> | undefined => data.countries
